import { useNavigate } from 'react-router-dom';

const bloomMark = process.env.PUBLIC_URL + '/BloomFavicon.png';

function Home() {
  const navigate = useNavigate();

  return (
    <div className="home">
      <main className="home-hero">
        <img className="home-mark" src={bloomMark} alt="Bloom" />
        <h1 className="home-wordmark">Bloom</h1>
        <p className="home-tagline">Digital Product Passports</p>

        <div className="home-paths">
          <button
            type="button"
            className="home-path-card"
            onClick={() => navigate('/brand')}
          >
            <span className="home-path-eyebrow">For Brands</span>
            <span className="home-path-title">Create and manage passports</span>
            <span className="home-path-desc">
              Issue verifiable passports for your jewellery and manage your catalogue.
            </span>
          </button>

          <button
            type="button"
            className="home-path-card"
            onClick={() => navigate('/user')}
          >
            <span className="home-path-eyebrow">For Owners</span>
            <span className="home-path-title">View your collection</span>
            <span className="home-path-desc">
              Access your passports, store documents, and care for your jewellery.
            </span>
          </button>
        </div>
      </main>
    </div>
  );
}

export default Home;
